import { useState } from "react"
import OnOffSwitch from "../OnOffSwitch/OnOffSwitch"

const PomodoroLink = "https://pomofocus.io"

const Pomodoro = () => {
    const [open, setOpen] = useState<boolean>(false)

    return <div className='flexVertical wherebyHolder' >
        
        <div className="flexHorizontal ">
            <div>Pomodoro PORTAL:</div>
            <OnOffSwitch state={open} onToggle={() => setOpen(!open)} connecting={false}/>
            <div style={{width: 48}} />
            <button onClick={() => window.open(PomodoroLink, "_blank")}>OPEN IN TAB</button>
        </div>
        
        {open ? 
            <iframe src={PomodoroLink} allow="camera *;microphone *" className="whereby"/> :
            null
        }
        
    </div>
}

export default Pomodoro